
import { ref } from '@vue/composition-api';
const __sfc_main = {};
__sfc_main.props = {
  max: {
    key: "max",
    required: false,
    type: Number,
    default: 3
  },
  items: {
    key: "items",
    required: false,
    type: Number,
    default: 0
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const isActive = ref(props.max >= props.items);
  function onClick() {
    isActive.value = !isActive.value;
  }
  return {
    isActive,
    onClick
  };
};
export default __sfc_main;
